import { useCallback, useContext, useEffect, useState } from 'react';
import { Modal, Platform, View } from 'react-native';
import { GuideHostedContext } from './GuideProvider';
import useGuideBlocker from '@/utils/hooks/useGuideBlocker';

export function useGuideSurface(surfaceID) {
    const hosted = useContext(GuideHostedContext);
    const hosting = !!surfaceID && !!hosted?.hostedSurfaces?.has(surfaceID);
    const shown = useCallback(() => hosted?.onSurfaceShown?.(surfaceID), [hosted?.onSurfaceShown, surfaceID]);
    const closed = useCallback(() => hosted?.onSurfaceClosed?.(surfaceID), [hosted?.onSurfaceClosed, surfaceID]);
    const selected = useCallback(() => hosted?.onSurfaceAction?.(surfaceID), [hosted?.onSurfaceAction, surfaceID]);
    return { hosting, overlay: hosting && hosted?.surfaceID === surfaceID ? hosted.overlay : null, shown, closed, selected };
}

export default function GuideSurface({ surfaceID, visible, children, onShow, onDismiss, ...props }) {
    const surface = useGuideSurface(surfaceID);
    const [closing, setClosing] = useState(false);
    const [previousVisible, setPreviousVisible] = useState(visible);
    if (visible !== previousVisible) {
        setPreviousVisible(visible);
        setClosing(previousVisible && !visible);
    }
    useGuideBlocker(closing || (visible && !surface.hosting));
    useEffect(() => {
        if (!closing || Platform.OS === 'ios') return;
        const timer = setTimeout(() => { setClosing(false); surface.closed(); }, 300);
        return () => clearTimeout(timer);
    }, [closing, surface.closed]);
    return <Modal {...props} visible={visible} onShow={() => { surface.shown(); onShow?.(); }} onDismiss={() => {
        setClosing(false);
        surface.closed();
        onDismiss?.();
    }}>
        <View style={{ flex: 1 }}>
            {children}
            {surface.overlay}
        </View>
    </Modal>;
}
